var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4999 12.666C68.2488 12.666 69.6666 14.0838 69.6666 15.8327V50.666C69.6666 52.4149 68.2488 53.8327 66.4999 53.8327H43.0666C43.0666 55.9441 44.1929 58.0556 46.4454 60.167L55.4166 60.166C56.291 60.166 56.9999 60.8749 56.9999 61.7493C56.9999 62.6238 56.291 63.3327 55.4166 63.3327H20.5833C19.7088 63.3327 18.9999 62.6238 18.9999 61.7493C18.9999 60.8749 19.7088 60.166 20.5833 60.166L29.5544 60.167C31.807 58.0556 32.9332 55.9441 32.9332 53.8327H9.49992C7.75102 53.8327 6.33325 52.4149 6.33325 50.666V15.8327C6.33325 14.0838 7.75102 12.666 9.49992 12.666H66.4999ZM66.4999 15.8327H9.49992V47.4993H66.4999V15.8327Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.5c0cfd77.svg";
export { ForwardRef as ReactComponent };